"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sessions = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/full_bathroom_renovation.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/full_bathroom_renovation.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/full_bathroom_renovation.png-wvc-sizes",
  alt: "Full bathroom remodel in Lakeland FL",
  month: "Full Bathroom Remodels",
  format: "COMPLETE OVERHAUL",
  titleStart: "Complete Bathroom Remodels",
  titleItalic: "",
  titleEnd: "",
  description: "Plan a full bathroom remodel with updates to showers, tubs, tile, flooring, vanities, fixtures, lighting, and layout. Request a quote for your Lakeland bathroom renovation project.",
  offset: false,
  href: "/bathroom-remodel/",
  buttonText: "View Bathroom Remodel Page"
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/walk_in_shower_lakeland.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/walk_in_shower_lakeland.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/walk_in_shower_lakeland.png-wvc-sizes",
  alt: "Walk-in shower remodel in Lakeland FL",
  month: "Shower Remodels",
  format: "SHOWER UPGRADE",
  titleStart: "Walk-In Shower Updates",
  titleItalic: "",
  titleEnd: "",
  description: "Request a quote for shower updates, walk-in showers, tile showers, glass doors, fixtures, and storage niches. Shower remodels can improve comfort, function, and daily use.",
  offset: true,
  href: "/shower-remodel-lakeland-fl/",
  buttonText: "View Shower Remodel Page"
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_vanity_fixtures.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_vanity_fixtures.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_vanity_fixtures.png-wvc-sizes",
  alt: "Bathroom vanity and fixture update in Lakeland FL",
  month: "Vanities and Fixtures",
  format: "VANITY SERVICES",
  titleStart: "Vanity, Sink, and Fixture Updates",
  titleItalic: "",
  titleEnd: "",
  description: "Update your bathroom with new vanities, sinks, faucets, mirrors, lighting, countertops, and storage options. Small fixture updates can make a bathroom feel cleaner and more modern.",
  offset: false,
  href: "/contact/#request-your-bathroom-remodel-quote",
  buttonText: "Request a Free Quote"
}, {
  id: 4,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_tile_flooring_lakeland.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_tile_flooring_lakeland.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_tile_flooring_lakeland.png-wvc-sizes",
  alt: "Bathroom tile and flooring update in Lakeland FL",
  month: "Tile and Flooring",
  format: "FLOORING SOLUTIONS",
  titleStart: "Bathroom Tile and Flooring Updates",
  titleItalic: "",
  titleEnd: "",
  description: "Get quote help for bathroom tile, flooring, water-resistant surfaces, and updated finishes. Tile and flooring choices can change the look, comfort, and daily use of the space.",
  offset: true,
  href: "/services/",
  buttonText: "View Services"
}, {
  id: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_lighting_hardware.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_lighting_hardware.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathroom_lighting_hardware.png-wvc-sizes",
  alt: "Bathroom lighting and hardware update in Lakeland FL",
  month: "Lighting and Fixtures",
  format: "FIXTURE UPGRADES",
  titleStart: "Faucets, Lighting, Mirrors, and Hardware",
  titleItalic: "",
  titleEnd: "",
  description: "Request a quote for bathroom fixture updates, including faucets, mirrors, lighting, hardware, towel bars, and other finishing touches.",
  offset: false,
  href: "/contact/#request-your-bathroom-remodel-quote",
  buttonText: "Request a Free Quote"
}, {
  id: 6,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathtub_replacement_lakeland.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathtub_replacement_lakeland.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/bathtub_replacement_lakeland.png-wvc-sizes",
  alt: "Bathtub replacement in Lakeland FL",
  month: "Tub Replacement",
  format: "TUB UPDATES",
  titleStart: "Bathtub and Tub/Shower Updates",
  titleItalic: "",
  titleEnd: "",
  description: "Request a quote for replacing an old bathtub, updating a tub and shower combination, or reviewing tub-to-shower conversion options for a bathroom remodel project.",
  offset: true,
  href: "/tub-replacement-lakeland-fl/",
  buttonText: "View Tub Replacement Page"
}];
export default function RemodelServices() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="3046" id="lakelandservicecards" className="bg-background py-24 md:py-32 lg:py-44">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div ref={header.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-end transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-8 lg:col-start-2">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-6">
              Bathroom Remodel Options
            </p>

            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-foreground mb-6">
              Bathroom Remodeling Services in Lakeland FL
            </h2>

            <p className="font-default text-lg text-muted-foreground max-w-2xl">
              Request quotes for bathroom remodeling services in Lakeland, FL,
              including shower remodels, tub replacements, walk-in showers,
              tile, flooring, vanities, fixtures, and full bathroom renovations.
            </p>

            <p className="mt-5 font-default text-base text-muted-foreground max-w-2xl">
              For larger projects, view our{" "}
              <Link to="/bathroom-remodel/" className="text-primary underline underline-offset-4 hover:text-primary/80 transition-colors">
                bathroom remodel services in Lakeland, FL
              </Link>
              .
            </p>
          </div>
        </div>

        <div className="mt-20 lg:mt-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {sessions.map((session, i) => {
          const card = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15,
            rootMargin: "0px 0px -50px 0px"
          });
          return <div key={session.id} data-index={i} ref={card.ref} className={`transition-all duration-[900ms] ease-out ${card.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"} ${session.offset ? "lg:mt-6" : ""}`} style={{
            transitionDelay: `${i % 3 * 120}ms`
          }}>
                <Card className="group h-full border border-border bg-card rounded-lg p-0 gap-0 transition-all duration-[800ms] ease-out hover:-translate-y-2 hover:shadow-lg">
                  <CardContent className="p-8 lg:p-10 flex flex-col h-full">
                    <div className="relative overflow-hidden rounded-lg aspect-[4/3] mb-8">
                      <img src={session.image} data-wvc-srcset={session.srcset} data-wvc-sizes={session.sizes} alt={session.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
                    </div>

                    <div className="flex items-baseline gap-3 mb-5">
                      <span className="font-default text-2xl text-foreground">
                        {session.month}
                      </span>
                    </div>

                    <h3 className="font-default text-2xl lg:text-[28px] leading-[1.2] text-foreground mb-4">
                      {session.titleStart}
                    </h3>

                    <p className="font-default text-base text-muted-foreground leading-relaxed mb-7">
                      {session.description}
                    </p>

                    <div className="mt-auto">
                      <Separator className="mb-8 bg-border" />

                      <Button asChild className="w-full rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-[11px] uppercase h-12">
                        <Link to={session.href}>
                          {session.buttonText}
                          <ArrowRight className="size-4" />
                        </Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-24 flex items-center justify-center gap-6">
          <Separator className="flex-1 bg-border" />
          <span className="font-default italic text-xl text-muted-foreground">
            &mdash;
          </span>
          <Separator className="flex-1 bg-border" />
        </div>
      </div>
    </section>;
}